import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Info } from '@material-ui/icons';
import { Modal, Button } from '@avangard/ui/core';
import { black, orange } from '@avangard/ui/colors';

type DialogSchoolDeleteProps = {
    loading: boolean;
    onAccept: () => Promise<void>;
};

const Header = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    padding-top: 16px;
    line-height: 22px;
`;

const Icon = styled.div`
    display: flex;
    width: 24px;
    height: 24px;
    color: ${orange[50]};
`;

const Title = styled.div`
    width: calc(100% - 32px);
    margin-inline-start: 8px;
    color: ${black[100]};
    font-size: 1.6rem;
`;

const Body = styled.div`
    width: 100%;
    margin-top: 8px;
    padding-inline-start: 32px;
    font-size: 1.4rem;
    line-height: 22px;
`;

const Actions = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-top: 24px;

    > * {
        &:not(:last-of-type) {
            margin-inline-end: 8px;
        }
    }
`;

const infoIcon = <Info style={{ fontSize: 24 }} />;

// TODO: create shared dialog component with render props
const DialogSchoolDelete = (props: DialogSchoolDeleteProps): React.ReactElement => {
    const { loading, onAccept } = props;

    const { t } = useTranslation(['common', 'schools']);

    const [open, setOpen] = React.useState(false);

    const handleOpen = (): void => setOpen(true);

    const handleClose = (): void => setOpen(false);

    const handleClickAccept = async (): Promise<void> => {
        await onAccept();
    };

    return (
        <>
            <Button variant='outlined' onClick={handleOpen}>
                {t('schools:delete_school.title')}
            </Button>

            <Modal hideCloseIcon open={open} onClose={handleClose}>
                <Header>
                    <Icon>{infoIcon}</Icon>
                    <Title>{t('schools:delete_school.confirm')}</Title>
                </Header>

                <Body>{t('schools:delete_school.hint')}</Body>

                <Actions>
                    <Button variant='outlined' disabled={loading} onClick={handleClose}>
                        {t('common:actions.cancel')}
                    </Button>

                    <Button loading={loading} onClick={handleClickAccept}>
                        {t('common:actions.remove')}
                    </Button>
                </Actions>
            </Modal>
        </>
    );
};

export { DialogSchoolDelete };
